import { post, setToken, setApiKey } from '../request';
import { BASE } from './config';

export const AuthApi = {
  refresh() {
    return post(`${BASE}/auth/refresh`, {});
  },
  sendCode(phone) {
    const payload = {
      phone,
      data: {},
      create_user: true,
      gotrue_meta_security: { captcha_token: null },
      channel: 'sms',
    };
    return post(
      `http://42.121.243.194/auth/v1/otp`,
      payload,
      { headers: AuthService.getOtpHeaders(), withAuth: false }
    );
  },
  login(phone, code) {
    const payload = {
      phone,
      token: code,
      type: 'sms',
      redirect_to: null,
      gotrue_meta_security: { captchaToken: null },
    };
    return post(
      `http://42.121.243.194/auth/v1/verify`,
      payload,
      { headers: AuthService.getAuthHeaders(), withAuth: false }
    );
  },
};

export const AuthService = {
  getAccessToken() {
    return (
      localStorage.getItem('access_token') ||
      localStorage.getItem('token') ||
      ''
    );
  },
  isAuthenticated() {
    return !!(
      localStorage.getItem('access_token') || localStorage.getItem('token')
    );
  },
  setAccessToken(token) {
    if (token) {
      localStorage.setItem('access_token', token);
      localStorage.setItem('token', token);
      setToken(token);
    }
  },
  setApiKey(key) {
    if (key) {
      setApiKey(key);
    }
  },
  getOtpHeaders() {
    const apiKey =
      (typeof window !== 'undefined' && window.__API_KEY__) ||
      localStorage.getItem('api_key') ||
      '';
    const tokenRaw =
      (typeof window !== 'undefined' && window.__AUTH_TOKEN__) ||
      localStorage.getItem('access_token') ||
      localStorage.getItem('token') ||
      '';
    const token = String(tokenRaw).trim();
    const headers = { 'Content-Type': 'application/json' };
    if (apiKey) headers.apikey = apiKey;
    if (token) {
      const bearer = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
      headers.Authorization = bearer;
      // headers.authorization = bearer;
    }
    return headers;
  },
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('token');
    setToken('');
  },
  getAuthHeaders() {
    const headers = { 'Content-Type': 'application/json' };
    const apiKey =
      (typeof window !== 'undefined' && window.__API_KEY__) ||
      localStorage.getItem('api_key') ||
      '';
    if (apiKey) headers.apikey = apiKey;
    const tokenRaw =
      (typeof window !== 'undefined' && window.__AUTH_TOKEN__) ||
      localStorage.getItem('access_token') ||
      localStorage.getItem('token') ||
      '';
    const token = String(tokenRaw).trim();
    if (token) {
      const bearer = token.startsWith('Bearer ') ? token : `Bearer ${token}`;

      headers.Authorization = bearer;
    }
    
    return headers;
  },
};
